"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _react = require("react");
var _Help = require("../Help");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _utils = require("../utils");
var _Clear = _interopRequireDefault(require("@mui/icons-material/Clear"));
var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));
var _InputBase = _interopRequireDefault(require("@mui/material/InputBase"));
var _styles = require("@mui/styles");
var _utils2 = require("@mui/utils");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _get = _interopRequireDefault(require("lodash/get"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["value", "placeholder", "onChange", "onClear", "minWidth", "margin", "disableBackground", "classes", "inputRef", "style", "throughFiltersComponent", "helperText"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DebounceInputBase = (0, _utils.withInputDebounce)()(_InputBase["default"]);
var dataCy = exports.dataCy = 'SearchInput';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    fullWidth: {
      width: "100%"
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&:focus': {
        backgroundColor: theme.palette.action.selected
      }
    },
    disabledSearch: {
      '&&&': {
        color: theme.palette.action.disabled,
        backgroundColor: theme.palette.action.disabledBackground
      }
    },
    disableBackground: {
      '&&&&': {
        background: 'none'
      }
    },
    searchIcon: {
      padding: theme.spacing(0, 1),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.text.secondary
    },
    closeIcon: {
      height: '100%',
      position: 'absolute',
      top: '0',
      right: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.text.secondary
      // '& > button': {
      //   color: 'inherit',
      // },
    },
    inputRoot: {
      color: 'inherit',
      width: '100%',
      paddingRight: function paddingRight(_ref) {
        var withThroughFilters = _ref.withThroughFilters,
          withClear = _ref.withClear;
        var width = 0;
        if (withThroughFilters) {
          width += 55;
        }
        if (withClear) {
          width += 40;
        }
        return "".concat(width, "px");
      }
    },
    inputInput: {
      color: theme.palette.text.primary,
      background: theme.palette.background.active,
      // vertical padding + font size from searchIcon
      padding: function padding(_ref2) {
        var margin = _ref2.margin;
        return margin === 'dense' ? theme.spacing(1, 1, 1, "calc(1em + ".concat(theme.spacing(3), ")")) : theme.spacing(1.5, 1, 1.5, "calc(1em + ".concat(theme.spacing(3), ")"));
      },
      transition: theme.transitions.create('width'),
      width: '100%'
    }
  };
}, {
  name: 'GgSearch'
});

// TODO: make local state for value

var SearchInput = function SearchInput(_ref3) {
  var value = _ref3.value,
    _ref3$placeholder = _ref3.placeholder,
    placeholder = _ref3$placeholder === void 0 ? 'Search' : _ref3$placeholder,
    _ref3$onChange = _ref3.onChange,
    onChange = _ref3$onChange === void 0 ? _noop["default"] : _ref3$onChange,
    _ref3$onClear = _ref3.onClear,
    onClear = _ref3$onClear === void 0 ? _noop["default"] : _ref3$onClear,
    minWidth = _ref3.minWidth,
    _ref3$margin = _ref3.margin,
    margin = _ref3$margin === void 0 ? 'dense' : _ref3$margin,
    disableBackground = _ref3.disableBackground,
    classesProps = _ref3.classes,
    inputRef = _ref3.inputRef,
    style = _ref3.style,
    _ref3$throughFiltersC = _ref3.throughFiltersComponent,
    ThroughFiltersComponent = _ref3$throughFiltersC === void 0 ? null : _ref3$throughFiltersC,
    helperText = _ref3.helperText,
    props = _objectWithoutProperties(_ref3, _excluded);
  var classes = _objectSpread(_objectSpread({}, useStyles({
    margin: margin,
    withThroughFilters: ThroughFiltersComponent,
    withClear: value
  })), classesProps);
  var debounceInputRef = (0, _react.useRef)();
  var handleChange = function handleChange(e) {
    onChange(e, e.target.value);
  };
  var handleClear = function handleClear(e) {
    (0, _get["default"])(debounceInputRef, 'current.cancel', _noop["default"])(e);
    onChange(e, '');
    onClear('');
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-cy": dataCy,
    className: (0, _clsx2["default"])(classes.search, _defineProperty(_defineProperty(_defineProperty({}, classes.fullWidth, props.fullWidth), classes.disabledSearch, props.disabled), classes.disableBackground, disableBackground)),
    style: _objectSpread({
      minWidth: minWidth
    }, style),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.searchIcon,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Search["default"], {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DebounceInputBase, _objectSpread({
      placeholder: placeholder,
      value: value,
      classes: {
        root: classes.inputRoot,
        input: classes.inputInput
      },
      inputRef: inputRef,
      onChange: handleChange,
      debounceInputRef: debounceInputRef,
      inputProps: {
        'data-cy-label': 'search'
      },
      "data-cy-role": 'input',
      "data-cy-label": placeholder,
      margin: margin
    }, props)), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: classes.closeIcon,
      children: [value ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
        size: 'small',
        "data-cy-icon": 'clear',
        "data-cy-action": 'clear',
        color: 'inherit',
        onClick: handleClear,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Clear["default"], {})
      }) : helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Help.Help, {
        style: {
          display: 'flex',
          marginRight: 6
        },
        color: 'inherit',
        children: helperText
      }) : null, ThroughFiltersComponent ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ThroughFiltersComponent, {
        value: value
      }) : null]
    })]
  });
};
SearchInput.propTypes = {
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   */
  autoComplete: _propTypes["default"].string,
  /**
   * 	If true, the input element will be focused during the first mountWithMuiThemeProvider.
   */
  autoFocus: _propTypes["default"].bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * 	The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['primary', 'secondary']),
  /**
   * The default input element value. Use when the component is not controlled.
   */
  defaultValue: _propTypes["default"].any,
  /**
   * 	If true, the input element will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * End InputAdornment for this component.
   */
  endAdornment: _propTypes["default"].node,
  /**
   * If true, the input will indicate an error. This is normally obtained via context from FormControl.
   */
  error: _propTypes["default"].bool,
  /**
   * 	If true, the input will take up the full width of its container.
   */
  fullWidth: _propTypes["default"].bool,
  /**
   * The id of the input element.
   */
  id: _propTypes["default"].string,
  /**
   * 	The component used for the input element. Either a string to use a HTML element or a component.
   */
  inputComponent: _propTypes["default"].elementType,
  /**
   * Attributes applied to the input element.
   */
  inputProps: _propTypes["default"].object,
  /**
   * Pass a ref to the input element.
   */
  inputRef: _utils2.refType,
  /**
   * 	If dense, will adjust vertical spacing. This is normally obtained via context from FormControl.
   */
  margin: _propTypes["default"].oneOf(['dense', 'none']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * If true, a textarea element will be rendered.
   */
  multiline: _propTypes["default"].bool,
  /**
   * Name attribute of the input element.
   */
  name: _propTypes["default"].string,
  /**
   * Callback fired when the input is blurred.
   *Notice that the first argument (event) might be undefined.
   */
  onBlur: _propTypes["default"].func,
  /**
   * Callback fired when the value is changed.
   */
  onChange: _propTypes["default"].func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes["default"].string,
  /**
   * It prevents the user from changing the value of the field (not from interacting with the field).
   */
  readOnly: _propTypes["default"].bool,
  /**
   * 	If true, the input element will be required.
   */
  required: _propTypes["default"].bool,
  /**
  * Number of rows to display when multiline option is set to true.
  */
  rows: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
     * Maximum number of rows to display.
      */
  rowsMax: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * Minimum number of rows to display.
   */
  rowsMin: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * Start InputAdornment for this component.
   */
  startAdornment: _propTypes["default"].node,
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes["default"].string,
  /**
   * The helper text content.
   */
  helperText: _propTypes["default"].string,
  /**
   * The value of the input element, required for a controlled component.
   */
  value: _propTypes["default"].any,
  style: _propTypes["default"].object,
  'data-cy': _propTypes["default"].string,
  variant: _propTypes["default"].string,
  width: _propTypes["default"].string,
  debounceTimeout: _propTypes["default"].number,
  disableBackground: _propTypes["default"].bool,
  onClear: _propTypes["default"].func
};
var _default = exports["default"] = SearchInput;